import {Classes, Overlay} from '@blueprintjs/core';
import React, {PureComponent} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputNotification from '../common/InputNotification';
import {Link} from 'react-router-dom'
import InputRegular from '../common/InputRegular';

class FeedInfoEditModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                name: ''
            },
            spinnerActive: false,
            fieldsCheckActive: false,
            errorsList: [],
            done: false
        };
    }

    doSubmit = async (e) => {
        await this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = await this.state.data.name ? false : true;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {
                this.setState({spinnerActive: true})
                const feed_id = await this.props.projectId ? this.props.projectId : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
                try {
                    const result = await http.patch('api/feed/' + feed_id, {name: this.state.data.name}, {headers: {authorization: getJwt()}});
                    await this.props.updateUserFromServer();
                    await this.setState({spinnerActive: false})

                    await toastr.success('Your new workspace name is ' + result.data.name);
                    await localStorage.setItem("name", JSON.stringify(result.data.name));
                    await this.props.handleClose();
                    await this.setState({data: {name: ''}, done: false})
                } catch (e) {
                    this.setState({spinnerActive: false})
                    toastr.error('Error with changing name');
                }
            } else {
                this.setState({spinnerActive: false})
            }
        }, 500)
    };

    checkInputNotification = () => {
        if (this.state.unsuccessfulPostCall) {
            return <InputNotification type={'danger'} text={'Not been able to create New Feed. Please try again.'}/>
        }
    };

    componentDidMount() {
        this.setState({
            data: {
                name: this.props.projectName
            }
        })
    }

    componentDidUpdate() {
        if (!this.state.data.name && this.props.projectName && !this.state.done) {
            this.setState({
                data: {
                    name: this.props.projectName
                },
                done: true
            })
        }
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }


    render() {
        let {visible_modal, onClickAway, teams, team_id, feed_name} = this.props;
// console.log("ReassignFeedModal team_id", team_id);
        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment" id='renameFeed' style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Rename Workspace</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                <InputRegular
                                    id="1"
                                    label1="Name"
                                    label2=""
                                    placeholder="Ex. My Website"
                                    type='project-name'
                                    onChange={(value) => this.setState({data: {name: value}})}
                                    value={this.state.data.name}
                                    required={true}
                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                    updateErrorsList={this.updateErrorsList}
                                    errorMessage="Name has to contain at least one letter (upper case A-Z, lower case a-z), numbers 0-9 and spaces. No special characters are allowed."
                                    spaceBellowInput={30}
                                />
                                {/*{this.checkInputNotification()}*/}
                                {/*{this.renderButton('Save', 'feed info edit', 'feed_info_edit', 'btn btn-action ',false)}*/}
                                <div className='justify-content-end flex-direction-row margin-bottom-20'>

                                    <button
                                        className='btn-white-border margin-bottom-20 margin-top-10 margin-right-10'
                                        onClick={() => {
                                            this.props.handleClose();
                                            this.setState({data: {name: ''}, done: false})
                                        }}>
                                        Cancel
                                    </button>
                                    {this.state.spinnerActive ?
                                        <button className='btn-action btn-spinner margin-bottom-20 margin-top-10'
                                                disabled={true}>Save <i className='fa fa-spin fa-spinner'></i></button>
                                        :
                                        <button className='btn-action margin-bottom-20 margin-top-10'
                                                onClick={this.doSubmit}>Save</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default FeedInfoEditModal;